import { getActionFactory } from './utils/action-class-factory';

const createAction = getActionFactory('ROOT');

export const ResetStore = createAction('RESET_STORE');
export const ResetCombinedPageStore = createAction('RESET_COMBINED_PAGE_STORE');
